import { IProdutoAutorizado } from "@/interfaces/IProdutoAutorizado";
import { createAction } from "@reduxjs/toolkit";

const sync = createAction(
  "PRODUTO_AUTORIZADO/sync",
  (items: IProdutoAutorizado[]) => ({
    payload: { items },
  })
);

export const produtoAutorizadoAction = { sync };
